// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3Y4-S","content":"RecentSearches_content__2z-Uj"};